module.exports = __webpack_public_path__ + "img/opening_balance.4a212114.png";